import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import ActivityAccordion from "./ActivityAccordion";
import type { ActivityWithDate } from "./activityHelpers";

export interface EnrichedActivity extends ActivityWithDate {
  avatarElement?: ReactNode;
  eventIcon?: React.ComponentType<any>;
  eventColor?: string;
  showRevert?: boolean;
}

export interface FilteredActivityListProps {
  activities: EnrichedActivity[];
  isLoading?: boolean;
  ariaLabel?: (count: number) => string;
  handleRevert: (
    key: string,
    oldValue: any,
    uniqueId: string | undefined,
  ) => Promise<void> | void;
  pendingRevertId?: string | null;
}

export default function FilteredActivityList({
  activities,
  isLoading = false,
  handleRevert,
  pendingRevertId,
  ariaLabel = (count) => `Showing ${count} activities`,
}: Readonly<FilteredActivityListProps>) {
  if (isLoading || !activities) {
    return null;
  }

  return (
    <Box sx={{ mt: 3 }}>
      {activities.length > 0 ? (
        <Box aria-label={ariaLabel(activities.length)}>
          <ActivityAccordion
            activities={activities}
            handleRevert={handleRevert}
            pendingRevertId={pendingRevertId}
          />
        </Box>
      ) : (
        <Typography
          role="status"
          aria-live="polite"
          sx={{ textAlign: "center", color: "text.secondary", mt: 12 }}
        >
          No activity for the selected filters.
        </Typography>
      )}
    </Box>
  );
}
